module.exports = __webpack_public_path__ + "static/media/SourceSansPro-SemiboldIt.a694313e.eot";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/SourceSansPro-SemiboldIt.eot
// module id = 89
// module chunks = 3